import { BaseBlock } from "./BaseBlock";

/**
 * Блок объяснения.
 *
 * Простое отображение HTML без интерактивности.
 */
export class ExplanationBlock extends BaseBlock {

    constructor(
        private readonly html: string
    ) {
        super();
    }

    public override mount(): void {

        this.root = document.createElement("div");

        this.root.className =
            "task explanation-task";

        this.root.innerHTML =
            this.html;

        super.mount();

    }

    public override update(): void {

        // Ничего.
    }

    public override unmount(): void {

        super.unmount();

    }

}